import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ComparisonSection } from './components/ComparisonSection';
import { AdvantagesSection } from './components/AdvantagesSection';
import { ProcessSection } from './components/ProcessSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from './components/FooterSection';
import { LanguageProvider, useLanguage } from './components/LanguageContext';
import { LanguageSelector } from './components/LanguageSelector';
function MainContent() {
  const {
    language
  } = useLanguage();
  // Don't render the main content until a language is selected
  if (!language) return null;
  return <div className="min-h-screen bg-navy-900 text-gray-100 font-sans selection:bg-amber selection:text-navy-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <div id="inicio" data-id="element-3">
          <HeroSection data-id="element-4" />
        </div>
        <div id="servicios" data-id="element-5">
          <ServicesSection data-id="element-6" />
        </div>
        <div id="comparacion" data-id="element-7">
          <ComparisonSection data-id="element-8" />
        </div>
        <div id="ventajas" data-id="element-9">
          <AdvantagesSection data-id="element-10" />
        </div>
        <div id="proceso" data-id="element-11">
          <ProcessSection data-id="element-12" />
        </div>
        <div id="contacto" data-id="element-13">
          <ContactSection data-id="element-14" />
        </div>
      </main>
      <FooterSection data-id="element-15" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-16">
      <LanguageSelector data-id="element-17" />
      <MainContent data-id="element-18" />
    </LanguageProvider>;
}